import classNames from 'classnames'
import React from 'react'
import { CTA } from 'src/components/framework/ui/cta'
import { SectionHeader } from 'src/components/framework/ui/section-header'

export const GraphicalHistory: React.FC = () => {
  return (
    <>
      <SectionHeader spacing={3}>Graphical History</SectionHeader>
      <div className={'pods'}>
        {CHARTS.map((chart, index) => (
          <div
            className={classNames('pods__item', 'stk-text-align-c')}
            key={index}
          >
            <span>{chart.name}</span>
            <div style={{ position: 'relative' }}>
              <img
                src={chart.image}
                width={chart.width}
                height={chart.height}
                alt={`Blurred out image of ${chart.name} chart`}
                loading={'lazy'}
                style={{ height: 'auto' }}
              />
              <CTA includeLabel={false} />
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

interface Chart {
  name: string
  image: string
  width: number
  height: number
}

const CHARTS: ReadonlyArray<Chart> = [
  {
    name: 'Revenue',
    image:
      'https://www.stockopedia.com/assets/conversion/images/revenue_blurred.jpg',
    width: 234,
    height: 155,
  },
  {
    name: 'Net Income',
    image:
      'https://www.stockopedia.com/assets/conversion/images/netincome_blurred.jpg',
    width: 236,
    height: 155,
  },
  {
    name: 'Normalised EPS',
    image:
      'https://www.stockopedia.com/assets/conversion/images/eps_blurred.jpg',
    width: 234,
    height: 155,
  },
  {
    name: 'PE Ratio Range',
    image:
      'https://www.stockopedia.com/assets/conversion/images/yield_blurred.jpg',
    width: 234,
    height: 155,
  },
  {
    name: 'Dividend Yield Range',
    image:
      'https://www.stockopedia.com/assets/conversion/images/dividend_blurred.jpg',
    width: 234,
    height: 155,
  },
]
